/** Whether a text control declares a character limit, narrowing it to a number. */
export const hasCharacterLimit = (maxlength: number | undefined): maxlength is number =>
  maxlength !== undefined
